import React from 'react';
import { useT } from '@transifex/react';
import getPageContent from 'utils/getPageContent';
import * as S from './styles';
import { PressPageContentProps } from '../../types';

export const FeaturedArticles = ({
  featuredArticlesData,
}: {
  featuredArticlesData: PressPageContentProps['contentData'];
}) => {
  const t = useT();
  return (
    <S.FeaturedArticles>
      {featuredArticlesData.map((featuredArticle) => getPageContent(featuredArticle, t, undefined))}
    </S.FeaturedArticles>
  );
};
